import classes from "./HomePage.module.css";
import Info from "../components/homepage/Info";
import Events from "../components/events/Events";

export default function Homepage() {
  return (
    <>
      <Info />
      <p className={classes.sectionTitle}>UPCOMING EVENTS</p>
      <Events title="UPCOMING EVENTS" />
    </>
  );
}
